<template>
    <v-layout class="component-wrap">
        <rating />
    </v-layout>
</template>

<script>
import rating from '@/components/view_blocks/Rating/Rating_wrap';
import {mapActions} from 'vuex';
export default {
  components: {
    rating,
  },
  mounted() {
    this.get_load_user();
  },
  methods: {
    ...mapActions('autorisation', [
      'get_load_user',
    ]),
  },
};
</script>
